import gql from 'graphql-tag';

const ConfirmConnectionMutation = gql`
  mutation ConfirmWearableConnection($provider: String!) {
    wearable {
      confirmConnection(provider: $provider) {
        ... on BasicMutationSuccess {
          __typename
        }
        ... on Error {
          code
          name
          description
          __typename
        }
      }
    }
  }
`;

export default ConfirmConnectionMutation;
